import { createAction } from 'redux-actions';
import * as companyFormTypes from './companyFormTypes';

export const duplicateCompany = createAction(companyFormTypes.DUPLICATE_COMPANY, companyId => ({ companyId }));
